module.exports = __webpack_public_path__ + "img/truck-performance-selected.b579a1b5.svg";